import React, { useEffect, useMemo, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import girlfriend from "../assets/girlfriend.jpeg";
import firstval from "../assets/firstval.jpeg";
import img0 from "../assets/img0.jpeg";
import img1 from "../assets/img1.jpeg";
import img2 from "../assets/img2.jpeg";
import img3 from "../assets/img3.jpeg";
import img4 from "../assets/img4.jpeg";
import img5 from "../assets/img5.jpeg";
import img6 from "../assets/img6.jpeg";
import img7 from "../assets/img7.jpeg";
import img8 from "../assets/img8.jpeg";
import img9 from "../assets/img9.jpeg";
import img11 from "../assets/img11.jpeg";
import img12 from "../assets/img12.jpeg";
import music from "../assets/webelongtogether.mp3";

export default function ValentinePage() {
  const [authorized, setAuthorized] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
  const [stage, setStage] = useState(0);
  const [closing, setClosing] = useState(false);
  const [vh, setVh] = useState(window.innerHeight);
  const [vw, setVw] = useState(window.innerWidth);
  const [typedFirst, setTypedFirst] = useState("");
  const [typedSecond, setTypedSecond] = useState("");
  const audioRef = useRef(null);
  const hasPlayedRef = useRef(false);
  const firstLine = "My baby";
  const secondLine = "forever!";
  const correctPassword = "daddysgirl";

  const backgroundImages = [img0, img1, img2, img3, img4, img5, img6, img7, img8, img9, img11, img12];

  useEffect(() => {
    const handleResize = () => { setVh(window.innerHeight); setVw(window.innerWidth); };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (stage === 1) {
      setTypedFirst("");
      setTypedSecond("");
      let i = 0;
      const startDelay = setTimeout(() => {
        const firstInterval = setInterval(() => {
          i++;
          setTypedFirst(firstLine.slice(0, i));
          if (i >= firstLine.length) {
            clearInterval(firstInterval);
            let j = 0;
            const secondInterval = setInterval(() => {
              j++;
              setTypedSecond(secondLine.slice(0, j));
              if (j >= secondLine.length) clearInterval(secondInterval);
            }, 180);
          }
        }, 180);
      }, 500);
      return () => clearTimeout(startDelay);
    }
    if (stage !== 1) { setTypedFirst(""); setTypedSecond(""); }
  }, [stage]);

  const floatingHearts = useMemo(() => Array.from({ length: 40 }).map((_, i) => ({ id: i, left: Math.random() * 100, duration: 3.5 + Math.random() * 1.5, size: 10 + Math.random() * 20, drift: (Math.random() - 0.5) * 60 })), []);
  const floatingPhotos = useMemo(() => backgroundImages.map((src, i) => ({ id: i, src, left: (i / backgroundImages.length) * 100 + (Math.random() - 0.5) * 8, duration: 14 + Math.random() * 6, rotate: (Math.random() - 0.5) * 40 })), []);
  const explosionHearts = useMemo(() => Array.from({ length: 60 }).map((_, i) => ({ id: i, x: (Math.random() - 0.5) * vw, y: (Math.random() - 0.5) * vh, size: 12 + Math.random() * 26, delay: Math.random() * 0.1 })), [vw, vh]);

  const HeartIcon = ({ size = 24, color = "white" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg"><path d="M12 21s-6.716-4.35-9.193-7.272C.83 11.64 1.143 8.64 3.514 6.84 5.3 5.49 7.9 5.91 9.25 7.62L12 11l2.75-3.38c1.35-1.71 3.95-2.13 5.736-.78 2.37 1.8 2.684 4.8.707 6.888C18.716 16.65 12 21 12 21z"/></svg>
  );

  const playAudio = () => {
    if (!audioRef.current || hasPlayedRef.current) return;
    audioRef.current.volume = 1;
    audioRef.current.muted = false;
    audioRef.current.play().then(() => { hasPlayedRef.current = true; }).catch(() => {});
  };

  const handleLogin = () => {
    if (password.toLowerCase() === correctPassword) { setAuthorized(true); setError(false); }
    else setError(true);
  };

  const handleOpen = () => { playAudio(); setOpen(true); };

  const handleCardClick = () => {
    if (closing) return;
    if (stage === 0) setStage(1);
    else if (stage === 1) setStage(2);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setClosing(true);
    setTimeout(() => { setStage(0); setOpen(false); setClosing(false); }, 900);
  };

  if (!authorized) return (
    <div style={{ minHeight: "100vh", background: "#d41f3a", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", color: "white" }}>
      <div style={{ marginBottom: "12px" }}><HeartIcon size={40} color="white" /></div><h2 style={{ marginBottom: "20px" }}>Enter Password</h2>
      <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} style={{ padding: "12px 16px", borderRadius: "10px", border: "none", marginBottom: "12px", fontSize: "16px" }} />
      <button onClick={handleLogin} style={{ padding: "10px 24px", borderRadius: "12px", border: "none", background: "white", color: "#d41f3a", cursor: "pointer" }}>Enter</button>
      {error && <p style={{ marginTop: "10px" }}>Wrong password</p>}
    </div>
  );

  return (
    <div style={{ minHeight: `${vh}px`, width: "100%", background: "#d41f3a", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", overflow: "hidden" }}>
      <audio ref={audioRef} src={music} loop preload="auto" />

      {floatingPhotos.map((p) => (
        <motion.img key={`photo-${p.id}`} src={p.src} initial={{ y: vh, opacity: 0.85, rotate: p.rotate }} animate={{ y: -400, rotate: p.rotate + 25 }} transition={{ duration: p.duration, repeat: Infinity, ease: "linear" }} style={{ position: "absolute", left: `${p.left}%`, width: "22vw", maxWidth: "160px", aspectRatio: "3/4", objectFit: "cover", borderRadius: "18px", boxShadow: "0 15px 35px rgba(0,0,0,0.5)", zIndex: 1 }} />
      ))}

      {floatingHearts.map((h) => (
        <motion.div key={`float-${h.id}`} initial={{ y: vh + 80, x: 0, opacity: 0.9 }} animate={{ y: -200, x: h.drift, opacity: 0.9 }} transition={{ duration: h.duration, repeat: Infinity, ease: "linear" }} style={{ position: "absolute", left: `${h.left}%`, top: 0, zIndex: 2 }}>
          <HeartIcon size={h.size} />
        </motion.div>
      ))}

      {!open && <button onClick={handleOpen} style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", borderRadius: "16px", fontSize: "clamp(16px,4vw,18px)", padding: "14px 32px", background: "white", color: "#d41f3a", border: "none", boxShadow: "0 10px 25px rgba(0,0,0,0.2)", zIndex: 10, cursor: "pointer" }}>Open Your Card</button>}

      <AnimatePresence>
        {open && (
          <motion.div key="card" initial={{ scale: 0.6, opacity: 0 }} animate={closing ? { scale: 0.2, rotate: 720, opacity: 0 } : { scale: 1, opacity: 1 }} exit={{ scale: 0.6, opacity: 0 }} transition={{ duration: 0.9, ease: "easeInOut" }} style={{ perspective: "1200px", zIndex: 10 }}>
            <motion.div animate={{ rotateY: stage === 2 ? 180 : 0 }} transition={{ duration: 1, ease: "easeInOut" }} style={{ transformStyle: "preserve-3d", position: "relative", width: "85vw", maxWidth: "340px", height: "80vh", maxHeight: "620px", cursor: "pointer" }} onClick={handleCardClick}>
              <div style={{ backfaceVisibility: "hidden", position: "absolute", inset: 0, background: "white", borderRadius: "24px", boxShadow: "0 20px 50px rgba(0,0,0,0.3)", border: "4px solid #d41f3a", display: "flex", flexDirection: "column", justifyContent: "space-between", padding: "20px", overflow: "hidden" }}>
                <div style={{ display: "flex", justifyContent: "space-between", color: "#d41f3a", fontWeight: "bold", fontSize: "clamp(18px,4vw,22px)" }}><span>E♥</span><span style={{ transform: "rotate(180deg)" }}>S♥</span></div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flex: 1, position: "relative" }}>
                  {stage === 0 && <HeartIcon size={Math.min(vw * 0.18, 80)} color="#d41f3a" />}
                  {stage === 1 && <div style={{ position: "absolute", bottom: "8%", left: "6%", fontStyle: "italic", fontFamily: "'Great Vibes', cursive", fontSize: "clamp(26px,6vw,44px)", color: "#d41f3a", transform: "rotate(-10deg)", textShadow: "0 6px 16px rgba(0,0,0,0.35)", zIndex: 10 }}><div style={{ minHeight: "1.2em" }}>{typedFirst}</div><div style={{ minHeight: "1.2em" }}>{typedSecond}</div></div>}
                  <motion.div initial={{ height: 0 }} animate={{ height: stage >= 1 ? "100%" : 0 }} transition={{ duration: 9, ease: [0.25, 0.8, 0.25, 1] }} style={{ position: "absolute", bottom: 0, left: 0, right: 0, overflow: "hidden" }}><img src={girlfriend} alt="Girlfriend" style={{ width: "100%", height: "100%", objectFit: "cover" }} /></motion.div>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", color: "#d41f3a", fontWeight: "bold", fontSize: "clamp(18px,4vw,22px)" }}><span>♥S</span><span style={{ transform: "rotate(180deg)" }}>♥E</span></div>
              </div>
              <div style={{ backfaceVisibility: "hidden", transform: "rotateY(180deg)", position: "absolute", inset: 0, background: "linear-gradient(to bottom right,#b71c32,#8f1426)", borderRadius: "24px", boxShadow: "0 20px 50px rgba(0,0,0,0.4)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", padding: "20px", color: "white", textAlign: "center" }}>
                <div style={{ width: "100%", height: "35%", borderRadius: "16px", overflow: "hidden", boxShadow: "0 10px 25px rgba(0,0,0,0.4)" }}><img src={firstval} alt="First Valentine" style={{ width: "100%", height: "100%", objectFit: "cover" }} /></div>
                <div style={{ width: "100%" }}>
                  <h2 style={{ fontSize: "clamp(20px,5vw,28px)", fontWeight: "bold", lineHeight: "1.3", marginTop: "12px" }}>Happy Valentines Day<br />Mama</h2>
<p style={{ fontSize: "clamp(12px,3.5vw,14px)", marginTop: "10px" }}>
  Happy Anniversary, my love. From the day we first met to forever ahead, it's always you and me.
</p>

<p style={{ fontSize: "clamp(12px,3.5vw,14px)", marginTop: "10px" }}>
  You are my calm, my joy, and my favorite adventure. My heart chose you then, and it still chooses you now and always. Today is about celebrating you, us, and the love we share. I can’t wait to experience life with you every day. I love you!
</p>                  <button onClick={handleClose} style={{ borderRadius: "16px", background: "white", color: "#d41f3a", border: "none", padding: "10px 24px", marginTop: "16px", cursor: "pointer", fontSize: "clamp(14px,4vw,16px)" }}>Close</button>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
